import React, {useState} from "react";
import CaseImageAttachment from "./CaseImageAttachment";
import CaseLocationDetails from "./CaseLocationDetails";
import {Button} from "antd";
import AlarmCaseDetails from "./CaseDetails/AlarmCaseDetails";
import {useForm} from "react-hook-form";
import {createDraftWorkforceDashboardData, createWorkforceDashboardData} from "../../../Services/workforce";
import {useDispatch} from "react-redux";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../store/features/loadingSlice";
import MeterLoggerCaseDetails from "./CaseDetails/MeterLoggerCaseDetails";
import DownloadDataManualReadCaseDetails from "./CaseDetails/DownloadDataManualReadCaseDetails";
import NotifyCreateRecordModal from "../../../components/Modals/NotifyCreateRecordModal";

const CaseDetailsComponent = ({createCaseId}) => {
    const dispatch = useDispatch();
    const {control, handleSubmit, setValue, watch} = useForm();
    const [showNotifyCreateRecordModal, setShowNotifyCreateRecordModal] = useState(false);

    const handleDataWithGeocode = (data, callToApi) => {

        const sanitizedAttachmentUrl = data?.attachmentUrls?.map(attachment => attachment?.response.map(v => v.url))?.flat();

        if (data?.geocode !== undefined && data?.geocode !== null) {
            const splitGeocode = data.geocode.toString().trim().split(",").map(codes => codes.trim());

            dispatch(SET_IS_API_CALLED("Creating New Case"));
            callToApi(0, {
                "attachmentUrls": sanitizedAttachmentUrl,
                "region": data?.region,
                "caseTypeId": data?.caseTypeId,
                "deviceId": data?.deviceId,
                "fullAddress": data?.fullAddress,
                "latitude": splitGeocode[0] ?? 0.0,
                "longitude": splitGeocode[1] ?? 0.0,
                "technicianGroupId": data?.technicianGroupId,
            }).then((response) => {
                if (response?.status < 400) {
                    setShowNotifyCreateRecordModal(true);
                }
            }).finally(() => {
                dispatch(SET_IS_API_CALLED_FINISHED());
            });
        }
    }

    const onSubmit = (data) => {
        handleDataWithGeocode(data, createWorkforceDashboardData);
    }

    const onDraftSubmit = (data) => {
        handleDataWithGeocode(data, createDraftWorkforceDashboardData);
    }

    return (
        <>
            <NotifyCreateRecordModal
                modalTitle={"Case Created"}
                modalText={`Your case has been created.`}
                setShowNotifyCreateRecordModal={setShowNotifyCreateRecordModal}
                showNotifyCreateRecordModal={showNotifyCreateRecordModal}
                redirectUrl={"/wf-case-listing"}
                timeout={1000}
            />
            <form>
                <div className="px-4 flex flex-col gap-5">
                    <p className="font-bold">Case Details</p>
                    <CreateCaseDetailsTypeSwitcher createCaseId={createCaseId} control={control} setValue={setValue}
                                                   watch={watch}/>
                    <CaseImageAttachment control={control}/>
                    <CaseLocationDetails control={control} handleSubmit={handleSubmit} setValue={setValue}/>
                    <div className="pt-4 grid grid-cols-5 gap-4">
                        <Button
                            onClick={handleSubmit(onDraftSubmit)}
                            className="col-end-5 bg-dark-blue-200 text-white"
                            type={"button"}
                        >
                            Draft
                        </Button>
                        <Button
                            onClick={handleSubmit(onSubmit)}
                            className="col-end-6 bg-dark-blue-200 text-white"
                            type={"button"}
                        >
                            Submit
                        </Button>
                    </div>
                </div>
            </form>
        </>
    );
};

const CreateCaseDetailsTypeSwitcher = ({createCaseId, control, setValue, watch}) => {

    const contentMap = [
        {
            createCaseId: 1,
            contentComponent: <AlarmCaseDetails createCaseId={createCaseId} control={control} setValue={setValue}
                                                watch={watch}/>,
        },
        {
            createCaseId: 2,
            contentComponent: <MeterLoggerCaseDetails createCaseId={createCaseId} control={control}
                                                      setValue={setValue} watch={watch}/>,
        },
        {
            createCaseId: 3,
            contentComponent: <DownloadDataManualReadCaseDetails createCaseId={createCaseId} control={control}
                                                                 setValue={setValue} watch={watch}/>,
        },
    ];


    return (
        <>
            {contentMap
                ?.filter((content) => {
                    if (createCaseId === 1) {
                        return content.createCaseId === 1;
                    } else if (createCaseId >= 2 && createCaseId <= 6) {
                        return content.createCaseId === 2;
                    } else {
                        return content.createCaseId === 3;
                    }
                    // content.createCaseId === createCaseId
                })
                .map((content) => content.contentComponent)}
        </>
    );
};

export default CaseDetailsComponent;
